export default __webpack_public_path__ + "static/media/07-icon-qualitaet.7f529dc0.svg";